import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHorizontalRule, faPlus } from '@fortawesome/pro-regular-svg-icons';
import React, { Component } from 'react';

import './MultiDayDivider.scss';
interface MultiDayDividerProps {
    isSelected: boolean;
    selectedColor: string;
}

class MultiDayDivider extends Component<MultiDayDividerProps> {
    render() {
        const horizontalRuleClass = this.props.isSelected ? { color: 'inherit' } : {};
        const plusIconClass = this.props.isSelected
            ? { color: this.props.selectedColor, width: ' 0.5em' }
            : { width: ' 0.5em' };
        return (
            <div className="multiDayIconSeparatorContainer">
                <FontAwesomeIcon
                    className="multiDayIconSeparator"
                    style={horizontalRuleClass}
                    icon={faHorizontalRule}
                />
                <FontAwesomeIcon className="multiDayIconSeparatorPlus" style={plusIconClass} icon={faPlus} />
                <FontAwesomeIcon
                    className="multiDayIconSeparator"
                    style={horizontalRuleClass}
                    icon={faHorizontalRule}
                />
            </div>
        );
    }
}

export default MultiDayDivider;
